import { Controller } from "@hotwired/stimulus";
import ColorCalc from "../models/color_calc";

export default class extends Controller {
  static targets = [
    "button",
    "colorInput",
    "textInput",
    "swatch",
    "wrapper",
    "hint",
    "contrastRatio",
  ];
  async connect() {
    this.currentValue = this.massageHex(this.textInputTarget.value);
    this.colorCalc = ColorCalc.get(this.currentValue);
    this.listeners = [];
    const element = this.element;
    if (this.hasColorInputTarget) {
      this.boundColorInput = (e) => {
        const newValue = e.target.value;
        this.textInputTarget.value = newValue;
        if (element.classList.contains("color-dropdown")) {
          this.buttonTarget.style.backgroundColor = newValue;
        }
        this.colorCalc = ColorCalc.get(newValue);
        this.checkColor(newValue);
        this.textInputTarget.dispatchEvent(new InputEvent("input"));
      };
      this.colorInputTarget.addEventListener("input", this.boundColorInput);
      this.listeners.push({
        target: this.colorInputTarget,
        event: "input",
        handler: this.boundColorInput,
      });
    }
    if (this.hasTextInputTarget) {
      this.boundTextInput = (e) => {
        this.colorCalc = ColorCalc.get(e.target.value);
        if (this.colorCalc) {
          this.hex = this.colorCalc.hex;
          this.textInputTarget.classList.remove("invalid-hex");
          this.colorInputTarget.value = this.colorCalc.hex;
          if (element.classList.contains("color-dropdown")) {
            this.buttonTarget.style.backgroundColor = this.hex;
          }
        } else {
          this.hex = null;
          this.textInputTarget.classList.add("invalid-hex");
        }
        this.checkColor(this.hex);
      };
      this.textInputTarget.addEventListener("input", this.boundTextInput);
      this.listeners.push({
        target: this.textInputTarget,
        event: "input",
        handler: this.boundTextInput,
      });

      this.boundTextChange = (e) => {
        this.colorCalc = ColorCalc.get(e.target.value);
        if (this.colorCalc) {
          this.hex = this.colorCalc.hex;
          this.textInputTarget.value = this.hex;
          this.textInputTarget.classList.remove("invalid-hex");
          this.colorInputTarget.value = this.hex;
        } else {
          this.textInputTarget.classList.add("invalid-hex");
        }
        this.checkColor(this.hex);
      };
      this.textInputTarget.addEventListener("change", this.boundTextChange);
      this.listeners.push({
        target: this.textInputTarget,
        event: "change",
        handler: this.boundTextChange,
      });

      const a11yModal = document.getElementById("a11y-modal");
      if (a11yModal && this.hasContrastRatioTarget) {
        this.boundContrastClick = () => {
          a11yModal.showModal();
        };
        this.contrastRatioTarget.addEventListener(
          "click",
          this.boundContrastClick,
        );
        this.listeners.push({
          target: this.contrastRatioTarget,
          event: "click",
          handler: this.boundContrastClick,
        });
      }
    }
    this.swatchTargets.forEach((target) => {
      const color = target.getAttribute("data-color");
      const handler = () => {
        if (this.hasColorInputTarget) {
          this.colorInputTarget.value = color;
        }
        if (this.hasTextInputTarget) {
          this.textInputTarget.value = color;
        }
        this.buttonTarget.style.backgroundColor = color;
        this.colorCalc = ColorCalc.get(color);
        this.checkColor(color);
      };
      target.addEventListener("click", handler);
      this.listeners.push({ target, event: "click", handler });
    });
    this.checkColor(this.currentValue);
  }

  disconnect() {
    this.listeners.forEach(({ target, event, handler }) => {
      target.removeEventListener(event, handler);
    });
  }

  checkColor(chosenColor) {
    let swatchName = null;
    let brushColor = null;
    let brushBackgroundColor = null;
    this.swatchTargets.forEach((target) => {
      const color = target.getAttribute("data-color");
      if (chosenColor == color) {
        target.classList.add("selected");
        swatchName = target.getAttribute("data-name");
        brushColor = color;
        brushBackgroundColor = target.getAttribute(
          "data-icon-background-color",
        );
      } else {
        target.classList.remove("selected");
      }
    });
    if (swatchName) {
      this.wrapperTarget.classList.add("with-palette-color");
      this.wrapperTarget.setAttribute(
        "style",
        `--brush-color: ${brushColor}; --brush-background-color: ${brushBackgroundColor}`,
      );
      if (this.hasHintTarget) {
        this.hintTarget.innerText = swatchName;
      }
    } else {
      this.wrapperTarget.classList.remove("with-palette-color");
      this.wrapperTarget.setAttribute("style", null);
      if (this.hasHintTarget) {
        this.hintTarget.innerText = "Or pick a color";
      }
    }
    if (!chosenColor) {
      this.wrapperTarget.setAttribute("style", null);
    }
    if (this.colorCalc) {
      if (this.colorCalc.passAA()) {
        this.element.classList.add("pass-aa");
      } else {
        this.element.classList.remove("pass-aa");
      }
      if (this.hasContrastRatioTarget) {
        this.contrastRatioTarget.innerText = this.colorCalc.contrastRatio();
      }
    } else {
      this.element.classList.remove("pass-aa");
    }
  }

  validHex(hex) {
    if (hex) {
      return /^#[0-9a-f]{6}$/i.test(hex);
    } else {
      return true;
    }
  }

  massageHex(hex) {
    if (!/^#/.test(hex)) {
      hex = `#${hex}`;
    }
    if (/^#?([0-9a-f]{3})$/i.test(hex)) {
      hex = `#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`;
    }
    if (hex == "#") {
      return "";
    } else {
      return hex.toLowerCase();
    }
  }
}
